import React from 'react';

function NotFoundScreen(props) {
    return (
        <div>
            <h1 style={{margin: 'auto'}}>NotFound</h1>
        </div>
    );
}

export default NotFoundScreen;